import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { WishListModule } from '@spartacus/cart/wish-list';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, StateModule, UrlModule } from '@spartacus/core';
import { MediaModule, StarRatingModule } from '@spartacus/storefront';
import { CustomProductItemModule } from '../../../../../custom/cms-components/content/custom-product-item/custom-product-item.module';
import { CustomStarRatingModule } from '../../../shared/components/custom-star-raiting/custom-star-rating.module';
import { CustomAddToCartModule } from '../../cart/custom-add-to-cart/custom-add-to-cart.module';
import { CustomAddToWishListModule } from '../../cart/custom-add-to-whish-list/custom-add-to-wish-list.module';
import { CustomCartSharedModule } from '../../cart/custom-cart-shared/custom-cart-shared.module';
import { CustomStockNotificationModule } from "../../product/custom-stock-notification/custom-stock-notification.module";
import { CustomWishlistItemComponent } from './custom-wishlist-item/custom-wishlist-item.component';
import { CustomWishlistComponent } from './custom-wishlist.component';
import { WishListEffects } from './store/effects/wish-list.effect';
import { reducerWishlistProvider, reducerWishlistToken } from './store/reducers/wishlist.reducer';
import { WISHLIST_FEATURE } from './store/wishlist-state';

const effects: any[] = [
  WishListEffects
];

@NgModule({
  imports: [
    CommonModule,
    StateModule,
    CustomCartSharedModule,
    StoreModule.forFeature(WISHLIST_FEATURE, reducerWishlistToken),
    EffectsModule.forFeature(effects),
    CustomStockNotificationModule,
    ConfigModule.withConfig({
      cmsComponents: {
        WishListComponent: {
          component: CustomWishlistComponent,
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
    I18nModule,
    UrlModule,
    MediaModule,
    RouterModule,
    CustomAddToCartModule,
    WishListModule,
    CustomStarRatingModule,
    StarRatingModule,
    CustomProductItemModule,
    CustomAddToWishListModule,
  ],
  declarations: [CustomWishlistComponent, CustomWishlistItemComponent],
  providers: [reducerWishlistProvider],
  exports: [CustomWishlistComponent, CustomWishlistItemComponent]
})
export class CustomWishlistStoreModule {
}
